import { MessageCircle } from "lucide-react";
import { Outlet, useParams } from "react-router-dom";
import { CookieBanner } from "@/components/CookieBanner";
import { Footer } from "@/components/Footer";
import { Header } from "@/components/Header";
import { business, copy } from "@/data/content";
import { Lang } from "@/types";

export default function Layout() {
  const params = useParams();
  const lang: Lang = params.lang === "en" ? "en" : "de";
  const whatsapp = `${business.whatsappUrl}?text=${encodeURIComponent(lang === "de" ? "Hallo Piccobello Chiemsee, ich interessiere mich für eine Reinigung." : "Hello Piccobello Chiemsee, I am interested in a cleaning service.")}`;
  return <><Header lang={lang} /><main><Outlet context={{ lang }} /></main><Footer lang={lang} /><a href={whatsapp} target="_blank" rel="noreferrer" className="whatsapp" aria-label={copy[lang].whatsapp} data-testid="sticky-whatsapp-link"><MessageCircle /><span>{copy[lang].whatsapp}</span></a><CookieBanner lang={lang} /></>;
}